import feedTypes from './feedTypes';

const INITIAL_STATE = {
  posts: [],
  fetching: true,
  error: false,
  hasMore: false,
};

const feedReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case feedTypes.FETCH_POSTS_START: {
      return {
        ...state,
        fetching: true,
        error: false,
      };
    }
    case feedTypes.FETCH_POSTS_SUCCESS: {
      return {
        ...state,
        fetching: false,
        error: false,
        posts: [...state.posts, ...action.payload],
        hasMore: action.payload.length === 5,
      };
    }
    case feedTypes.FETCH_POSTS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    }
    case feedTypes.ADD_POST: {
      return {
        ...state,
        posts: [action.payload, ...state.posts],
      };
    }
    case feedTypes.REMOVE_POST: {
      const posts = JSON.parse(JSON.stringify(state.posts));
      const postIndex = posts.findIndex((post) => post._id === action.payload);
      if (postIndex) {
        posts.splice(postIndex, 1);
      }
      return {
        ...state,
        posts,
      };
    }
    case feedTypes.CLEAR_POSTS: {
      return {
        ...state,
        posts: [],
      };
    }
    case 'INCREMENT_POST_COMMENTS_COUNT': {
      const postId = action.payload;
      if (!postId) {
        return state;
      }
      const posts = state.posts.map((post) => {
        const currentId =
          (post._id && post._id.toString()) ||
          (post.postId && post.postId.toString());
        if (currentId !== postId.toString()) {
          return post;
        }
        const existing =
          typeof post.commentCount === 'number'
            ? post.commentCount
            : typeof post.commentData?.commentCount === 'number'
            ? post.commentData.commentCount
            : typeof post.commentData?.totalCount === 'number'
            ? post.commentData.totalCount
            : Array.isArray(post.commentData?.comments)
            ? post.commentData.comments.length
            : Array.isArray(post.comments)
            ? post.comments.length
            : 0;
        const nextCount = existing + 1;
        return {
          ...post,
          commentCount: nextCount,
          commentData: {
            ...(post.commentData || {}),
            commentCount: nextCount,
            totalCount:
              typeof post.commentData?.totalCount === 'number'
                ? nextCount
                : post.commentData?.totalCount,
          },
        };
      });
      return {
        ...state,
        posts,
      };
    }
    case 'SET_POST_VOTES_COUNT': {
      const {
        postId,
        postVotes,
        voteCount,
        reactionType,
        likeCount: nextLikeCount,
      } = action.payload || {};
      if (!postId) {
        return state;
      }
      const posts = state.posts.map((post) => {
        const currentId =
          (post._id && post._id.toString()) ||
          (post.postId && post.postId.toString());
        if (currentId !== postId) {
          return post;
        }
        const hadReaction = post.reactionType === 'like';
        const hasReaction = reactionType === 'like';
        const incomingLikeCount =
          typeof nextLikeCount === 'number' ? nextLikeCount : null;
        let likeCount =
          incomingLikeCount !== null ? incomingLikeCount : post.likeCount || 0;
        if (incomingLikeCount === null && typeof reactionType !== 'undefined') {
          if (hasReaction && !hadReaction) {
            likeCount += 1;
          } else if (!hasReaction && hadReaction) {
            likeCount = Math.max(0, likeCount - 1);
          }
        }
        return {
          ...post,
          postVotes: Array.isArray(postVotes) ? postVotes : post.postVotes,
          postVotesCount:
            typeof voteCount === 'number' ? voteCount : post.postVotesCount,
          likeCount,
          reactionType:
            typeof reactionType !== 'undefined' ? reactionType : post.reactionType,
        };
      });
      return {
        ...state,
        posts,
      };
    }
    default: {
      return state;
    }
  }
};

export default feedReducer;
